var map = {
	"./img/ammiraglio/ammiraglio 1.jpeg": "2213",
	"./img/ammiraglio/ammiraglio 2.jpeg": "2620",
	"./img/ammiraglio/ammiraglio 3.jpeg": "45cc",
	"./img/ammiraglio/ammiraglio 4 bagno.jpeg": "2feb",
	"./img/ammiraglio/ammiraglio 5.jpeg": "7894",
	"./img/ammiraglio/ammiraglio 6.jpeg": "5028",
	"./img/ammiraglio/ammiraglio 7 bagno.jpeg": "64c6",
	"./img/ammiraglio/ammiraglio 8 .jpeg": "e856",
	"./img/ammiraglio/ammiraglio 9 bagno.jpeg": "d162",
	"./img/ammiraglio/ammiraglio10.jpeg": "30e8",
	"./img/anto_milo.jpeg": "f966",
	"./img/award_2020.png": "f826",
	"./img/capitano/capitano 1.jpeg": "4eaf",
	"./img/capitano/capitano 2.jpeg": "06e0",
	"./img/capitano/capitano 3.jpeg": "8f37",
	"./img/capitano/capitano 4.jpeg": "9274",
	"./img/capitano/capitano 5 bagno.jpeg": "175c",
	"./img/cibo/arancini.jpeg": "dcbd",
	"./img/cibo/bollitore.jpeg": "2489",
	"./img/cibo/colazione_1.jpeg": "fec6",
	"./img/cibo/colazione_1.jpeg.old.jpeg": "e44b",
	"./img/cibo/colazione_2.jpeg": "53b1",
	"./img/cibo/colazione_3.jpeg": "d9f8",
	"./img/cibo/colazione_4.jpeg": "8fcb",
	"./img/cibo/colazione_5.jpeg": "c8a5",
	"./img/cibo/colazione_6.jpeg": "2ae7",
	"./img/cibo/vino.jpeg": "67f4",
	"./img/dettagli/dettaglio bagno 2.jpeg": "74b3",
	"./img/dettagli/dettaglio bagno.jpeg": "c2e0",
	"./img/dettagli/dettaglio chiavi 2.jpeg": "0db0",
	"./img/dettagli/dettaglio chiavi.jpeg": "b9dc",
	"./img/dettagli/servizi 2.jpeg": "32b7",
	"./img/dettagli/servizi.jpeg": "999c",
	"./img/dettagli/set cortesia 2.jpeg": "8c42",
	"./img/dettagli/set cortesia.jpeg": "dbfe",
	"./img/mozzo/mozzo 2.jpeg": "405d",
	"./img/mozzo/mozzo 3.jpeg": "246a",
	"./img/mozzo/mozzo 5 balcone.jpeg": "7c55",
	"./img/mozzo/mozzo1.jpeg": "89c6",
	"./img/mozzo/mozzo6.jpeg": "1e9d",
	"./img/nostromo/nostromo 1.jpeg": "1436",
	"./img/nostromo/nostromo 2.jpeg": "5a6b",
	"./img/nostromo/nostromo 3.jpeg": "c68f",
	"./img/nostromo/nostromo 4 bagno.jpeg": "c7ab",
	"./img/nostromo/nostromo 5 balcone.jpeg": "8052",
	"./img/oblo/corridoio 1.jpeg": "9503",
	"./img/oblo/corridoio 2.jpeg": "c932",
	"./img/oblo/corridoio 3.jpeg": "4102",
	"./img/oblo/corridoio 4.jpeg": "943b",
	"./img/oblo/paesaggio 1.jpeg": "8fd7",
	"./img/oblo/paesaggio 2.jpeg": "e3f8",
	"./img/oblo/paesaggio 2_med.jpeg": "b876",
	"./img/oblo/paesaggio 3.jpeg": "c4a9",
	"./img/oblo/paesaggio 4.jpeg": "90fb",
	"./img/oblo/paesaggio5.jpeg": "2b51",
	"./img/oblo/piazza 1.jpeg": "73a0",
	"./img/oblo/piazza 2.jpeg": "1907",
	"./img/oblo/reception 1.jpeg": "4f13",
	"./img/oblo/reception 2.jpeg": "581e",
	"./img/oblo/reception_fix.jpg": "5bbd",
	"./img/promo/cenone_capodanno.png": "ee4c",
	"./img/promo/promo_49.jpeg": "6534",
	"./img/promo/promo_49.png": "dd06",
	"./img/promo/s_agata.jpg": "1ecd",
	"./img/promo/santagata.jpeg": "6853",
	"./img/promo/sanvalentino.jpeg": "0917",
	"./img/thumbs/ammiraglio_min.jpeg": "f0f0",
	"./img/thumbs/capitano_min.jpeg": "e768",
	"./img/thumbs/mozzo_min.jpeg": "3df2",
	"./img/thumbs/nostromo_min.jpeg": "ad3d",
	"./isometric.png": "176f",
	"./it-flag.png": "392e",
	"./logo.png": "cf05",
	"./logo_large.png": "adee",
	"./uk-flag.jpg": "f821"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";